import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexNonAxisChartSeries,
  ApexTitleSubtitle,
  ChartComponent,
} from 'ng-apexcharts';
import {
  ChartOptions,
  DashboardChartInput,
  DEFAULT_APEX_CHART,
  DEFAULT_APEX_OPTIONS,
  DEFAULT_DONUT_OPTIONS,
} from '../common-apex';

@Component({
  selector: 'app-donut-card',
  templateUrl: './donut-card.component.html',
  styleUrls: ['./donut-card.component.scss'],
})
export class DonutCardComponent implements OnInit {
  @ViewChild(ChartComponent) chart: ChartComponent;

  @Input() data: DashboardChartInput;
  @Input() values: ApexAxisChartSeries | ApexNonAxisChartSeries;
  @Input() formatter: (w?: any) => string;

  public chartOptions: Partial<ChartOptions>;
  constructor() {}

  ngOnInit() {
    this.chartOptions = {
      ...DEFAULT_APEX_OPTIONS,
      title: this.data.title,
      // series: this.data.values,
      chart: {
        ...DEFAULT_APEX_CHART,
        height: this.data?.height ?? undefined,
        // width: this.data?.width ?? undefined,
        type: 'donut',
      },
      stroke: {
        width: 0,
      },
      labels: this.data.labels,
      plotOptions: {
        ...DEFAULT_DONUT_OPTIONS,
        ...this.data.plotOptions,
      },
      colors: this.data.colors,
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'left',
      },
      grid: {
        padding: {
          left: 0,
          right: 0,
        },
      },
      tooltip: this.data.tooltip,
    };
  }
}
